/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil, exhaustMap, tap, mapTo } from 'rxjs/operators';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { from, of } from 'rxjs';
import {
    CashBoxAuditTabAction,
    CashBoxAuditTabActionType,
    fetchCashBoxAuditHistorySuccessAction,
    fetchCashBoxAuditHistoryErrorAction,
    downloadAuditHistorySuccessAction,
    downloadAuditHistoryErrorAction,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxAuditTabActions';
import { downloadDataAsFile, parseError } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';
import { AxiosError } from 'axios';

export const fetchCashBoxAuditHistoryEpic: Epic<CashBoxAuditTabAction> = (action$) => {
    return action$.pipe(
        ofType(CashBoxAuditTabActionType.FETCH_CASHBOX_AUDIT_HISTORY),
        switchMap((action) => {
            const { taxNumber, params } = action.payload;
            const listName = i18n.t('RegistryScreens.cashBoxAuditHistory').toLowerCase();

            return from(cashboxesClient.getCashBoxAuditHistory(taxNumber, params)).pipe(
                map((resp) => {
                    return fetchCashBoxAuditHistorySuccessAction(resp);
                }),
                catchError((err: AxiosError) =>
                    of(
                        fetchCashBoxAuditHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedLoadList', { listName })),
                        ),
                    ),
                ),
                takeUntil(action$.pipe(ofType(CashBoxAuditTabActionType.EXIT_CASHBOX_AUDIT_TAB))),
            );
        }),
    );
};

export const cashBoxAuditHistoryDownloadEpic: Epic<CashBoxAuditTabAction> = (actions$) => {
    return actions$.pipe(
        ofType(CashBoxAuditTabActionType.DOWNLOAD_AUDIT_HISTORY),
        exhaustMap((action) => {
            const { taxNumber, params } = action.payload;
            const fileName = `cashbox_${taxNumber}_AuditHistory.xls`;

            return from(cashboxesClient.downloadCashBoxAuditHistoryAsExcel(taxNumber, params)).pipe(
                tap((fileData) => downloadDataAsFile(fileName, fileData)),
                mapTo(downloadAuditHistorySuccessAction()),
                catchError((err: AxiosError) =>
                    of(
                        downloadAuditHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedUploadFileName', { fileName })),
                        ),
                    ),
                ),
            );
        }),
    );
};
